export default "__VITE_ASSET__CBdEaM0g__"